import { Component, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { SigneringHistorikData, VirkeskopskontraktDigitalSigneringViewModel } from "~app/features/virkeskop/models/kontrakt-models";
import { KontraktDigitalsigneringItemComponent } from "../kontrakt-digitalsignering-item/kontrakt-digitalsignering-item.component";

@Component({
    selector: "rask-kontrakt-digitalsignering-historik",
    templateUrl: "./kontrakt-digitalsignering-historik.component.html",
    styleUrl: "./kontrakt-digitalsignering-historik.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        KontraktDigitalsigneringItemComponent,
        ButtonComponent
    ]
})
export class KontraktDigitalsigneringHistorikComponent {
    @Input() set data(value: SigneringHistorikData) {
        this.signeringar = value.signeringar;
    }
    signeringar: VirkeskopskontraktDigitalSigneringViewModel[];
    modal = inject(NgbActiveModal);
    dismiss() {
        this.modal.close(ConfirmDialogResponse.cancel);
    }
}
